module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-lg-12",
    attrs: {
      "id": "drought-strip"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }]
  }, [(this.stripType === 'drought') ? _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Drought Level (" + _vm._s(_vm.areaType) + " Wide Palmer Drought Index)")]) : (this.stripType === 'precip') ? _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Precipitation Level (" + _vm._s(_vm.areaType) + " Wide)")]) : _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Temperature Level (" + _vm._s(_vm.areaType) + " Wide)")]), _vm._v(" "), (this.stripType === 'drought') ? _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top-palmer"
  }, [_vm._v("\n      The "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Palmer_drought_index"
    }
  }, [_vm._v("Palmer Drought Index")]), _vm._v("\n      is a measure of long term drought. It calculates soil moisture based on\n      recent precipitation and temperature. 0 is considered a normal level of soil moisture,\n      while increasingly negative numbers indicate progressively severe levels of drought.\n      Positive numbers represent increasingly wet soil conditions. Compare the Palmer Index to the\n      temperature and precipitation levels below. Recent droughts have tended to have hotter  temperatures\n      than usual. This results in increased levels of\n      "), _c('a', {
    staticClass: "inside",
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Evapotranspiration"
    }
  }, [_vm._v("evapotranspiration")]), _vm._v("\n      from the soil and plants, leading to more\n      severe droughts and worse Palmer Index numbers.")]) : _vm._e(), _vm._v(" "), (this.stripType === 'drought') ? _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10"
  }, [_vm._v("\n      Note: Hover over a bar to see the value for a particular month.")]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Departure from Average (Avg Anomaly)")])]), _vm._v(" "), _c('legend-chart', {
    attrs: {
      "colors": _vm.colors,
      "dataValues": _vm.dataValues,
      "field": _vm.legend_field
    }
  }), _vm._v(" "), _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "id": "strip",
      "height": "110",
      "width": _vm.width_large
    }
  }, [_vm._l((_vm.data), function(d) {
    return [_c('rect', {
      attrs: {
        "x": _vm.scale(d.date),
        "y": "0",
        "height": _vm.height,
        "width": _vm.barWidth,
        "fill": _vm.stripColor(d.anomaly),
        "transform": _vm.offset
      },
      on: {
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(_vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(_vm.tipDiv, $event)
        }
      }
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a37f93a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StripChart.vue
// module id = 376
// module chunks = 1